import {get, ref, remove, set, update} from "firebase/database";
import {database} from "../utils/firebase";
import {ADMIN_CONFIG_PATHS} from "../config/adminConfig";

const WIT_TRAINING_QUEUE_PATH = ADMIN_CONFIG_PATHS.witTrainingQueue;

const normalizeQueueEntries = (value) => {
  if (!value) {
    return [];
  }
  return Object.entries(value).map(([id, entry]) => ({id, ...entry}));
};

const sortEntries = (entries) => [...entries].sort((a, b) => {
  const aTime = new Date(a.updatedAt || a.createdAt || 0).getTime();
  const bTime = new Date(b.updatedAt || b.createdAt || 0).getTime();
  return bTime - aTime;
});

const witTrainingQueueService = {
  async loadQueueEntries() {
    const snapshot = await get(ref(database, WIT_TRAINING_QUEUE_PATH));
    if (!snapshot.exists()) {
      return [];
    }
    return sortEntries(normalizeQueueEntries(snapshot.val()));
  },

  async clearQueueEntries() {
    await remove(ref(database, WIT_TRAINING_QUEUE_PATH));
  },

  async saveQueueEntry(entryId, payload) {
    await set(ref(database, `${WIT_TRAINING_QUEUE_PATH}/${entryId}`), payload);
  },

  async updateQueueEntry(entryId, patch) {
    await update(ref(database, `${WIT_TRAINING_QUEUE_PATH}/${entryId}`), patch);
  },
};

export default witTrainingQueueService;
